import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import './BurgerButton.module.scss'

const BurgerButton = ({ menuToggle, click }) => (
  <div styleName={classnames('burger', { active: menuToggle })} onClick={() => click()}>
    <span styleName='line line-one' />
    <span styleName='line line-two' />
    <span styleName='line line-three' />
  </div>
)

BurgerButton.propTypes = {
  menuToggle: PropTypes.bool.isRequired,
  click: PropTypes.func
}

BurgerButton.defaultProps = {
  click: () => {}
}

export default BurgerButton



// WEBPACK FOOTER //
// ./src/components/BurgerButton/BurgerButton.js